import { api } from '../api'

/**
 * Jobs data layer
 * 
 * Provides methods to read and manipulate tools data
 * Depends on an API module that provides HTTP methods
 * 
 * @param {object} api - API module to interact with the server
 * @param object.get - GET method
 * @param object.post - POST method
 */
const CookiesAPI = () => {
    return {
        getAllCookies,
        createCookie,
        deleteCookie,
        updateCookie,
    }

    /**
     * Retrieve a list of all jobs and their associated information
     * 
     * Information about the tool, about metrics and about logs
     */
    async function getAllCookies(limit, offset, ordering) {
        const cookies = await api.get(`/api/scrapery/cookies?limit=${limit}&offset=${offset}&ordering=${ordering}`)
        const { results, count } = cookies
        return {
            cookies: results.map(j => ({ ...j, key: j.id })),
            count
        }
    }


    /**
     * Create a new cookie
     */
    async function createCookie(cookie) {
        const url = "api/scrapery/cookies"

        const {
            account_type,
            name,
            cookie_value,
        } = cookie

        const data = new FormData()

        data.append("acc_type", account_type)
        data.append("name", name)
        data.append("cookie_value", cookie_value)

        return await api.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }


    /**
     * Delete a cookie
     */
    async function deleteCookie(jobId) {
        const url = `api/scrapery/cookies/${jobId}`

        return await api.delete(url)
    }

    /**
   * Edit a cookie
   */
    async function updateCookie(cookieDetails, cookie_id) {
        const url = "/api/scrapery/cookies/" + cookie_id
        const data = new FormData()

        data.append("acc_type", cookieDetails.account_type)
        data.append("name", cookieDetails.name)
        data.append("cookie_value", cookieDetails.cookie_value)
        data.append("is_active", cookieDetails.is_active)
        data.append("demerit", cookieDetails.demerit)
        
        // submit form data 
        return await api.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    }
}


export default CookiesAPI